import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { CIRCLE_DOMAIN } from "@/react/components/constants";

interface ExistingAccountErrorProps {
  loginUrl: string;
}

export const ExistingAccountError = ({
  loginUrl,
}: ExistingAccountErrorProps) => {
  const localeScope = "authentication_app.signup.form.errors.existing_account";

  return (
    <div className="form-hint alert alert-warning mt-4 text-sm">
      {t(`${localeScope}.text_1`)}
      <a href={`https://${CIRCLE_DOMAIN}`}>{t("circle")}</a>
      {t(`${localeScope}.text_2`)}
      <br />
      <br />
      <div>
        {t(`${localeScope}.text_3`)}
        <Link id="existing-account-error-link" to={loginUrl}>
          {t(`${localeScope}.text_4`)}
        </Link>
        {t(`${localeScope}.text_5`)}
      </div>
    </div>
  );
};
